export const EVENT_COMMON_EXPOSURE_CHANGE = "common.exposure_change"; // 用于元素曝光检测
const GLOBAL_KEY = "_global";

const observers: any = {
  [GLOBAL_KEY]: undefined, // 默认 observer，root 为顶级文档的视窗
};
interface ObserverEventParams {
  show: boolean;
}

const showEvent: CustomEvent<ObserverEventParams> | null =
  typeof window === "undefined"
    ? null
    : new CustomEvent(EVENT_COMMON_EXPOSURE_CHANGE, {
        detail: { show: true },
      });
const hideEvent: CustomEvent<ObserverEventParams> | null =
  typeof window === "undefined"
    ? null
    : new CustomEvent(EVENT_COMMON_EXPOSURE_CHANGE, {
        detail: { show: false },
      });
const callback = (entries: any[], _observer: any) => {
  entries.forEach((entry) => {
    // Each entry describes an intersection change for one observed
    // target element:
    //   entry.boundingClientRect
    //   entry.intersectionRatio
    //   entry.intersectionRect
    //   entry.isIntersecting
    //   entry.rootBounds
    //   entry.target
    //   entry.time
    const { intersectionRatio, isIntersecting, target } = entry;
    if (isIntersecting && intersectionRatio > 0.3) {
      target.dispatchEvent(showEvent);
    }
    if (!isIntersecting && intersectionRatio <= 0) {
      target.dispatchEvent(hideEvent);
    }
  });
};

export const initObserver = (id?: string) => {
  const viewportEle = id ? document.getElementById(id) : null;
  if (id && !viewportEle) {
    throw Error(`容器${id}不存在`);
    // return;
  }
  const options = {
    root: id ? viewportEle : null,
    rootMargin: "0px",
    threshold: [0, 0.3],
  };

  const key = id || GLOBAL_KEY;
  if (!observers[key]) {
    observers[key] = new IntersectionObserver(callback, options);
  }
};
export const getObserver = (key = GLOBAL_KEY) => observers[key];

export const addObserver = (
  key = GLOBAL_KEY,
  target: HTMLElement | null | undefined
) => {
  const observer = getObserver(key);
  if (target) {
    observer.observe(target);
  }
};

export const removeObserver = (
  key = GLOBAL_KEY,
  target: HTMLElement | null | undefined
) => {
  const observer = getObserver(key);
  if (target) {
    observer.unobserve(target);
  }
};
